import { useQuery } from 'react-query';

import { getSignedTemplatesRoute } from '@features/digitalOnboarding/api/constants';
import axiosInstance from '@server/axiosInstance';

type UseGetSignedTemplatesProps = {
  applicationId: number;
  enabled?: boolean;
};

export const useGetSignedTemplates = ({
  applicationId,
  enabled,
}: UseGetSignedTemplatesProps) => {
  const signedTemplatesKey = 'signedTemplates';

  const {
    data: signedTemplatesData,
    isLoading: isSignedTemplatesLoading,
  } = useQuery({
    queryKey: [signedTemplatesKey, applicationId],
    queryFn: () =>
      axiosInstance
        .post(getSignedTemplatesRoute, { application_id: applicationId })
        .then((res) => res.data),
    refetchOnWindowFocus: false,
    enabled:  enabled,
  });

  return {
    signedTemplatesData,
    isSignedTemplatesLoading
  };
};
